import { httpClientOmni } from "@/libraries";

export default {

    async datatable(payload) {
        const response = await httpClientOmni.get(
            `reporting/v3/conversation-tag-history`,
            {
                params: payload,
            },
        );
        return response;
    },

    async exportExcel(payload) {
        const response = await httpClientOmni.get(
            `reporting/v3/conversation-tag-history/export`,
            {
                params: payload,
            },
            // {
            //     responseType: "blob",
            // }
        );
        return response;
    },
};
